import React, { useState, useEffect } from 'react';
import { Col, Row, Image, Dropdown, DropdownButton, Modal } from 'react-bootstrap';
import styles from './pendingOnboarding.module.scss';
import { CustomSearch } from '../../shared/customSearch';
import { getPendingOnboards, getHiringPiepelinesOfOnboards, pushedToOnboarding, rejectOnOnboarding, pushToHris, getExportDetails } from '../../../services/util/pendingOverboarding';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import CustomNavbar from '../customNavbar';
import makeAnimated from 'react-select/animated';
import Select from 'react-select'
import Avatar from 'react-avatar';
import { CustomConfirmationBox } from '../../shared/customConfirmationBox';
import { CustomConfirmationModal } from '../../shared/customConfirmationModal';
import { CustomButton } from '../../shared/customButton';
import { CustomIconButton } from '../../shared/customIconButton';
import CSSLoader from '../../shared/cssLoader';
import { useParams, useNavigate } from 'react-router-dom';
import ExportCSVModal from '../../adminPanel/common/exportCSVModal';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import ViewOfferDetailsModal from '../offerHandling/viewOfferModal';

const PendingOverboarding = (props) => {
    const animatedComponents = makeAnimated();

    const history = useNavigate();

    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let selected_pipeline = (params.get('pipeline') ? params.get('pipeline') : null);

    //set an state for default seleted pipeline type
    let [defaultSelectedPendingOnboardingPipeline, setDefaultSelectedPendingOnboardingPipeline] = useState({
        label: "All"
    })

    let [noSearchData, setNoSearchData] = useState(false)

    let viewPermission = props.permissions.actions.view_onboards;
    let editPermission = props.permissions.actions.edit_onboards;
    let viewOfferPermission = props.permissions.actions.view_offers
    let userRole = props.role;

    let [pendingOnboardingListDropDownArray, setPendingOnboardingListDropDownArray] = useState({});

    //on change pipeline type
    const changePendingOnboardingPipeline = async (type) => {
        let is_all = false;
        let respond;
        setIsDataLoading(true);
        setDefaultSelectedPendingOnboardingPipeline(type);
        setIsDataLoading(true);
        if (type.value === 100) {
            is_all = true;
            respond = await getPendingOnboards(null, is_all);
        }
        else {
            respond = await getPendingOnboards(type.value, is_all);
        }
        if (respond.success === true) {
            setArrayValues(respond.data)
            setFilteredValues(respond.data)
            setIsDataLoading(false)
        } else {
            setIsDataLoading(false)
        }
    };

    const breadcrumb = [{
        pathaddress: '/app/company/pending-onbaording',
        pathname: 'Pending Onboarding',
        isActive: false,
        key: 1 + 'pending-onboarding'
    }]

    const breacrumbText = 'In here you can see candidates who have accepted your job offers and waiting to onboard. Once you marked them as onboarded, they will disappear from this list. But you can still see their profile via the vacancy pipeline.'

    // States
    let [getUsersIsLoading, getUsersSetLoading] = useState(false);
    let [isDataLoading, setIsDataLoading] = useState(false);
    const [showExportCsvModal, setShowExportCsvModal] = useState(false);
    const [showPushedToOnboarding, setShowPushedToOnboarding] = useState(false);
    const [showRejectOnOnboarding, setShowRejectOnOnboarding] = useState(false);
    const [showPushToHris, setShowPushToHris] = useState(false);
    let [showOfferModal, setShowOfferModal] = useState(false);
    let [offerModalData, setOfferModalData] = useState();

    let [modalActionButtonLoading, setModalActionButtonLoading] = useState(false);
    let [selectedCandidateName, setSelectedCandidateName] = useState('');

    let [selectedPendingOnboardingSessionID, setPendingOnboardingSessionID] = useState('');

    let [value, setArrayValues] = useState([]);
    let [filteredValues, setFilteredValues] = useState([]);

    let [exportDetails, setExportDetails] = useState();

    let [isURLLoading, setURLLoading] = useState(false);

    // functions
    const handleClose = () => {
        setShowExportCsvModal(false);
        setShowPushedToOnboarding(false);
        setShowRejectOnOnboarding(false);
        setShowPushToHris(false);
        setShowOfferModal(false);

    }

    const onClickPushedToOnboarding = async (values) => {
        setSelectedCandidateName(values.candidate_name);
        setPendingOnboardingSessionID(values._onboarding_session_id);
        setShowPushedToOnboarding(true);
    }

    const onClickRejectOnOnboarding = async (values) => {
        setSelectedCandidateName(values.candidate_name);
        setPendingOnboardingSessionID(values._onboarding_session_id);
        setShowRejectOnOnboarding(true);
    }

    const onClickPushToHris = async (values) => {
        setSelectedCandidateName(values.candidate_name);
        setPendingOnboardingSessionID(values._onboarding_session_id);
        setShowPushToHris(true);
    }

    const openExportModal = async () => {
        setShowExportCsvModal(true);
    }

    const submitpushedToOnboarding = async (data) => {
        setModalActionButtonLoading(true)
        let respond = await pushedToOnboarding(selectedPendingOnboardingSessionID, data.reason);
        if (respond.success === true) {
            getAllPendingOverboardings()
            setModalActionButtonLoading(false)
            setShowPushedToOnboarding(false)
            props.GetTaskValues()
        } else {
            setModalActionButtonLoading(false)
        }
    }

    const submitRejectOnOnboarding = async (data) => {
        setModalActionButtonLoading(true)
        let respond = await rejectOnOnboarding(selectedPendingOnboardingSessionID, data.reason);
        if (respond.success === true) {
            getAllPendingOverboardings()
            setModalActionButtonLoading(false)
            setShowRejectOnOnboarding(false)
            props.GetTaskValues()
        } else {
            setModalActionButtonLoading(false)
        }
    }

    const submitPushToHris = async () => {
        setModalActionButtonLoading(true)
        let respond = await pushToHris(selectedPendingOnboardingSessionID);
        if (respond.success === true) {
            getAllPendingOverboardings()
            setModalActionButtonLoading(false)
            setShowPushToHris(false)
            props.GetTaskValues()
        } else {
            setModalActionButtonLoading(false)
        }
    }

    function searchValus(searchValue) {
        let searchVal = searchValue.toLowerCase();
        const filtered = value.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(searchVal)));
        setFilteredValues(filtered);
        if (filtered.length === 0) {
            setNoSearchData(true)
        }
    }

    const getAllPendingOverboardings = async () => {
        setIsDataLoading(true)
        let responds = await getHiringPiepelinesOfOnboards();
        let pending_onboarding_dropdown_array = [{
            label: 'All',
            value: 100
        }];
        if (responds.success === true) {
            for (let index = 0; index < (responds.data).length; index++) {
                let pending_onboarding_object = {
                    label: (responds.data)[index].pipeline_name,
                    value: (responds.data)[index].pipeline_id
                }
                pending_onboarding_dropdown_array.push(pending_onboarding_object);

            }
            setPendingOnboardingListDropDownArray(pending_onboarding_dropdown_array)
            let is_all = true;
            //setting pipleine label for selected pipeline
            if (selected_pipeline) {
                is_all = false;
                for (let index = 0; index < pending_onboarding_dropdown_array.length; index++) {
                    if (pending_onboarding_dropdown_array[index].value == selected_pipeline) {
                        setDefaultSelectedPendingOnboardingPipeline(pending_onboarding_dropdown_array[index]);

                    }
                }
            }

            let respond = await getPendingOnboards(selected_pipeline, is_all);
            if (respond.data.length < 1 && (selected_pipeline != 100)) {
                changeSelectedPipeline(100);
            }
            setArrayValues(respond.data)
            setFilteredValues(respond.data)
            setIsDataLoading(false)
        } else {
            setIsDataLoading(false)
        }
    }

    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }


    const viewOfferModal = async (values) => {
        let offer_data = {
            candidateId: values.candidate_id,
            offerSessionId: values.offer_details.offer_session_id,
            jobTitle: values.offer_details.offer_data.non_sensitive_data.job_title,
            allocation: values.offer_details.offer_data.non_sensitive_data.allocation,
            offerDescription: values.offer_details.offer_data.non_sensitive_data.description,
            packageReference: values.offer_details.offer_data.non_sensitive_data.package_reference,
            offerReviewers: values.offer_details.offer_data.assigned_reviewers,
            pipelineName: values.pipeline_name,
            candidateName: values.candidate_name,
            candidateEmail: values.candidate_email,
            candidatePhoneCode: values.candidate_mobile_country_code,
            candidatePhoneNumber: values.candidate_mobile_number,
            state: values.offer_details.offer_state,
            stateValue: values.offer_details.state_value,
            offer_sent_date: values.offer_details.offer_sending_details ? values.offer_details.offer_sending_details.offer_sent_date : null,
            offer_sent_mode: values.offer_details.offer_sending_details ? values.offer_details.offer_sending_details.offer_sent_mode : null,
            candidate_respose_received_mode: values.offer_details.candidate_respose_received_mode ? values.offer_details.candidate_respose_received_mode : null,
            candidate_respose_date: values.offer_details.candidate_respose_date,
            offer_documents: values.offer_documents ? values.offer_documents : null,
        }
        await setOfferModalData(offer_data);
        setShowOfferModal(true);
    }

    const getAllExportDetails = async () => {

        if ((editPermission && (userRole === 10)) || (userRole === 0)) {

            let response = await getExportDetails();

            setExportDetails(response.data);
        }

    }

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            className={styles.userIcon}
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className={styles.svgIconsMainDiv}>
                <div className={styles.userIconSvgDiv}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10.0001 10.8333C10.4603 10.8333 10.8334 10.4602 10.8334 9.99992C10.8334 9.53968 10.4603 9.16659 10.0001 9.16659C9.53984 9.16659 9.16675 9.53968 9.16675 9.99992C9.16675 10.4602 9.53984 10.8333 10.0001 10.8333Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 4.99992C10.4603 4.99992 10.8334 4.62682 10.8334 4.16659C10.8334 3.70635 10.4603 3.33325 10.0001 3.33325C9.53984 3.33325 9.16675 3.70635 9.16675 4.16659C9.16675 4.62682 9.53984 4.99992 10.0001 4.99992Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 16.6666C10.4603 16.6666 10.8334 16.2935 10.8334 15.8333C10.8334 15.373 10.4603 14.9999 10.0001 14.9999C9.53984 14.9999 9.16675 15.373 9.16675 15.8333C9.16675 16.2935 9.53984 16.6666 10.0001 16.6666Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                {children}
            </div>
        </a>
    ));

    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(filteredValues.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(filteredValues.length / itemsPerPage);

    const changeSelectedPipeline = async (selected_pipeline_id) => {
        history({
            pathname: `/company/pending-onboarding`,
            search: `?pipeline=${selected_pipeline_id}`
        });
    }

    useEffect(() => {
        getAllExportDetails();
        let unmounted = false;
        if (!unmounted) {
            getAllPendingOverboardings();
        }
        return () => { unmounted = true };
    }, []);

    useEffect(() => {
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
    }, [])

    // View
    return (
        <div>
            <Helmet>
                <title>Pending Onboarding | HireTrace</title>
            </Helmet>


            {/* Modal View End */}

            <CustomConfirmationModal
                show={showPushedToOnboarding}
                confirmationType='success'
                cancelIconclick={handleClose}
                onSecondaryBtnClick={handleClose}
                onPrimaryBtnClick={submitpushedToOnboarding}
                isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                confirmationTopic="Are you sure?"
                confirmationMessage={`You are trying to push ${selectedCandidateName} to Onboarding.`}
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Yes, Push To Onboarding!"
            />

            <CustomConfirmationBox
                show={showRejectOnOnboarding}
                cancelIconclick={handleClose}
                onSecondaryBtnClick={handleClose}
                onFormSubmit={submitRejectOnOnboarding}
                preCheckedCondition={true}
                isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message={`You are trying to reject ${selectedCandidateName} on onboarding.`}
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, Reject On Onboarding"
            />

            <CustomConfirmationModal
                show={showPushToHris}
                confirmationType='success'
                cancelIconclick={handleClose}
                onSecondaryBtnClick={handleClose}
                onPrimaryBtnClick={submitPushToHris}
                isSecondaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                isPrimaryBtnDisabled={modalActionButtonLoading === true ? true : false}
                primaryBtnBackSideIcon={modalActionButtonLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                confirmationTopic="Are you sure?"
                confirmationMessage={`You are trying to push candidate ${selectedCandidateName} to HRIS`}
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Yes, Push To HRIS!"
            />

            {showExportCsvModal && <ExportCSVModal
                show={showExportCsvModal}
                handleClose={handleClose}
                Title="Pending Onboarding"
                exportDetails={exportDetails}
                filename="Onboarding-details"
            />}

            {
                showOfferModal &&
                <ViewOfferDetailsModal
                    showModal={showOfferModal}
                    handleClose={handleClose}
                    viewOfferValues={offerModalData}
                // data={offerModalData}
                />
            }
            {isDataLoading ?
                <div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>
                :
                <div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb}  breacrumbText= {breacrumbText}/>
                    </div>

                    <div className={styles.BodyContainer}>
                        <Col>
                            <div>
                                <Row>
                                    <Col sm={3} className="mb-2 ms-3">
                                        <Select
                                            options={pendingOnboardingListDropDownArray}
                                            class="react-select__control"
                                            components={animatedComponents}
                                            value={defaultSelectedPendingOnboardingPipeline}
                                            onChange={(e) => {
                                                changePendingOnboardingPipeline(e);
                                                changeSelectedPipeline(e.value)
                                            }}
                                            styles={
                                                {
                                                    ...styles,
                                                    control: (base, state) => ({
                                                        ...base,
                                                        '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                        border: '1px solid #D0D5DD', // default border color
                                                        borderRadius: '6px',
                                                        boxShadow: 'none', // no box-shadow
                                                        height: '44px',
                                                        fontFamily: 'var(--app-primary-font-style)',
                                                        fontWeight: 'var(--app-regular-font-weight)',
                                                        fontSize: 'var(--app-primary-font-size)',
                                                    }),
                                                    option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                        return {
                                                            ...styles,
                                                            background: isDisabled
                                                                ? null
                                                                : isSelected
                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                    : isFocused
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : null,
                                                            color: isDisabled
                                                                ? '#ccc'
                                                                : isSelected
                                                                    ? '#24859A'
                                                                    : '#24859A',
                                                            cursor: isDisabled ? 'not-allowed' : 'default',

                                                            ':active': {
                                                                ...styles[':active'],
                                                                background:
                                                                    !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                            },
                                                        };
                                                    },
                                                }
                                            }
                                        />
                                    </Col>
                                    <Col sm={7} className="mb-2">
                                        <CustomSearch
                                            placeholder="Search pipeline name"
                                            handleOnChange={(e) => searchValus(e.target.value)}
                                        />
                                    </Col>
                                    <Col className="me-3">
                                        <CustomButton
                                            buttonType="button"
                                            label="Export"
                                            type="primaryBtn"
                                            disabled={((props.permissions.actions.edit_onboards === false && props.role === 1))}
                                            showToolTip={(props.permissions.actions.edit_onboards === false && props.role === 1) ? true : false}
                                            toolTip={`You don't have enough permissions to perform this action`}
                                            toolTipId={`permissionDenied`}
                                            frontIcon={
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download">
                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4">
                                                    </path>
                                                    <polyline points="7 10 12 15 17 10"></polyline>
                                                    <line x1="12" y1="15" x2="12" y2="3"></line>
                                                </svg>

                                            }
                                            handleClick={() => openExportModal()}

                                        />
                                    </Col>
                                </Row>
                            </div>
                        </Col>


                        <div className={styles.tableBodyContainer}>
                            {
                                ((filteredValues.length === 0) && (isDataLoading === false)) ?
                                    (<div>
                                        {noSearchData ?
                                            <Col>
                                                <p className={styles.infoMessage}>No records found for your search, Try a different keyword. </p>
                                            </Col>
                                            :
                                            <div>
                                                <Col>
                                                    <p className={styles.infoMessage}>Currently no Hired Candidates to onboard. Learn more
                                                        about  <a className={styles.linkText} href='https://hiretrace.io/documentation/onboarding/overview' target="_blank">Pending Onboarding</a>. </p>
                                                </Col>
                                                <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                                    <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/noOffers.svg`} fluid />
                                                </Col>
                                            </div>


                                        }

                                    </div>)
                                    :
                                    (<>
                                        <div className={styles.tableContainer}>
                                            <div className={styles.tableFirstRowMainHeaderDiv}>
                                                <Col sm={4} className={styles.tablePipelineDetailsMainHeaderRow}>
                                                    <p>Candidate Details</p>
                                                </Col>
                                                <Col sm={2} className={styles.tableStstusDetailsMainHeaderRow}>
                                                    <p>Phone Number</p>
                                                </Col>
                                                <Col sm={1}></Col>
                                                <Col sm={2}>
                                                    <Row className={styles.tableInfoDetailsMainHeaderRow}>
                                                        <p>Position/Pipeline</p>
                                                    </Row>
                                                </Col>
                                                <Col sm={2}>
                                                    <Row className={styles.tableCandidatesInfoDetailsHeaderRow}>
                                                        <p>Actions</p>
                                                    </Row>
                                                </Col>
                                                <Col sm={1}>

                                                </Col>
                                            </div>
                                            {filteredValues?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((pendingOnboard, i) => {
                                                return (
                                                    <div className={i % 2 === 0 ? styles.tableRowMainDiv : styles.tableRowSecondMainDiv}>
                                                        <Col sm={4}>
                                                            <Row className={styles.tableJobDetailsMainRow}>
                                                                <Col sm={2}>
                                                                    <Avatar name={pendingOnboard.candidate_name} size="32" round={true} />
                                                                </Col>
                                                                <Col sm={10}>
                                                                    <Row className={styles.tableJobDetailsRow}>
                                                                        <p className={styles.tableJobDetails}>{pendingOnboard?.candidate_name}</p>
                                                                    </Row>
                                                                    <Row className={styles.tableJobDetailsRow}>
                                                                        <p className={styles.tableSecondJobDetails}>{pendingOnboard?.candidate_email}</p>
                                                                    </Row>
                                                                </Col>

                                                            </Row>

                                                        </Col>
                                                        <Col sm={2}>
                                                            <Row className={styles.tableCandidatesInfoDetailsRow}>
                                                                <p className={styles.tableCandidatesInfoDetails}>({pendingOnboard?.candidate_mobile_country_code}) {pendingOnboard?.candidate_mobile_number}</p>
                                                            </Row>
                                                        </Col>
                                                        <Col sm={1}></Col>
                                                        <Col sm={2}>
                                                            <div className={styles.tableJobPositionMainRow}>
                                                                <Row className={styles.tableJobDetailsSecondRow}>
                                                                    <p className={styles.tableJobDetails}>{pendingOnboard?.offer_details.offer_data.non_sensitive_data.job_title}</p>
                                                                </Row>
                                                                <Row className={styles.tableJobDetailsSecondRow}>
                                                                    <p className={styles.tableSecondJobDetails}>{pendingOnboard?.pipeline_name}</p>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                        <Col sm={2}>
                                                            <Row >
                                                                <div className={styles.tableShareLinksRow}>
                                                                    <div className={styles.tableDatActionsLeftBtns}>
                                                                        <CustomIconButton
                                                                            type="successBtn"
                                                                            toolTipId={"viewCandidate"}
                                                                            showToolTip={true}
                                                                            toolTip={'view candidate'}
                                                                            icon={
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 20 21" fill="none">
                                                                                    <path d="M13.3333 15.5L15.8333 13M15.8333 13L18.3333 15.5M15.8333 13V18M9.99996 13.4167H6.24996C5.08699 13.4167 4.5055 13.4167 4.03234 13.5602C2.96701 13.8834 2.13333 14.717 1.81016 15.7824C1.66663 16.2555 1.66663 16.837 1.66663 18M12.0833 6.75C12.0833 8.82107 10.4044 10.5 8.33329 10.5C6.26222 10.5 4.58329 8.82107 4.58329 6.75C4.58329 4.67893 6.26222 3 8.33329 3C10.4044 3 12.0833 4.67893 12.0833 6.75Z" stroke="#344054" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </svg>
                                                                            }
                                                                            handleClick={() => viewCandidate(pendingOnboard.candidate_id)}
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <CustomIconButton
                                                                            type="successBtn"
                                                                            toolTipId={"viewOffer"}
                                                                            showToolTip={true}
                                                                            toolTip={'view offer'}
                                                                            icon={
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 20 21" fill="none">
                                                                                    <path d="M7.50004 10.0833L9.16671 11.75L12.9167 8M16.6667 10.5C16.6667 14.5904 12.2051 17.5653 10.5817 18.5124C10.3972 18.62 10.305 18.6738 10.1748 18.7018C10.0737 18.7234 9.92634 18.7234 9.82531 18.7018C9.69512 18.6738 9.60287 18.62 9.41838 18.5124C7.79501 17.5653 3.33337 14.5904 3.33337 10.5V6.51467C3.33337 5.84841 3.33337 5.51528 3.44234 5.22892C3.5386 4.97595 3.69503 4.75023 3.89809 4.57128C4.12795 4.3687 4.43987 4.25173 5.06371 4.01779L9.53188 2.34223C9.70512 2.27726 9.79175 2.24478 9.88086 2.2319C9.9599 2.22048 10.0402 2.22048 10.1192 2.2319C10.2083 2.24478 10.295 2.27726 10.4682 2.34223L14.9364 4.01779C15.5602 4.25173 15.8721 4.3687 16.102 4.57128C16.3051 4.75023 16.4615 4.97595 16.5577 5.22892C16.6667 5.51528 16.6667 5.84841 16.6667 6.51467V10.5Z" stroke="#344054" stroke-opacity="0.7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </svg>
                                                                            }
                                                                            className={(!pendingOnboard.offer_details) ? styles.dropdownTextDisabled : styles.dropdownText}
                                                                            disabled={(!pendingOnboard.offer_details) ? true : false}
                                                                            handleClick={() => viewOfferModal(pendingOnboard)}

                                                                        />
                                                                    </div>
                                                                    </div>
                                                            </Row>
                                                        </Col>

                                                        <Col sm={1}>
                                                            <Row className={styles.tableOptionRow}>
                                                                <div className={styles.tableOptionIconDiv}>
                                                                    <Dropdown
                                                                        alignRight={true}
                                                                    >
                                                                        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu className={styles.dropdownMenu}>
                                                                            <Dropdown.Item onClick={() => viewCandidate(pendingOnboard.candidate_id)} className={styles.dropdownText}>View Candidate</Dropdown.Item>
                                                                            <span>
                                                                                <Dropdown.Item className={(!pendingOnboard.offer_details) ? styles.dropdownTextDisabled : styles.dropdownText} onClick={() => viewOfferModal(pendingOnboard)} disabled={(!pendingOnboard.offer_details) ? true : false}>View Offer</Dropdown.Item>
                                                                            </span>
                                                                            <span>
                                                                                <Dropdown.Item className={(pendingOnboard.state != 0) ? styles.dropdownTextDisabled : styles.dropdownText} onClick={() => onClickPushedToOnboarding(pendingOnboard)} disabled={(pendingOnboard.state != 0) ? true : false}>Pushed To Onboarding</Dropdown.Item>
                                                                            </span>
                                                                            <span>
                                                                                <Dropdown.Item className={(pendingOnboard.state != 0) ? styles.dropdownTextDisabled : styles.dropdownText} onClick={() => onClickRejectOnOnboarding(pendingOnboard)} disabled={(pendingOnboard.state != 0) ? true : false}>Reject On Onboarding</Dropdown.Item>
                                                                            </span>
                                                                            <Dropdown.Divider />
                                                                            <span data-tooltip-id={!(pendingOnboard.is_push_to_hris_enable) ? `ConnectHRISInfo` : null}>
                                                                                <Dropdown.Item className={(pendingOnboard.state != 0) || !(pendingOnboard.is_push_to_hris_enable) ? styles.dropdownTextDisabled : styles.dropdownText} onClick={() => onClickPushToHris(pendingOnboard)} disabled={(pendingOnboard.state != 0) || !(pendingOnboard.is_push_to_hris_enable) ? true : false}>Push To HRIS</Dropdown.Item>
                                                                            </span>

                                                                            <ReactTooltip id={`PermissionDeniedInfo`} place="left" type="dark" effect="solid" >
                                                                                <div className={styles.toolTipBoxNew}>{<p>Permission denied.</p>}</div>
                                                                            </ReactTooltip>
                                                                            <ReactTooltip id={`ConnectHRISInfo`} place="left" type="dark" effect="solid" >
                                                                                <div className={styles.toolTipBoxNew}>{<p>Connect HRIS.</p>}</div>
                                                                            </ReactTooltip>

                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                            </Row>
                                                        </Col>
                                                    </div>
                                                );

                                            })
                                            }
                                        </div>
                                        <div>
                                            {filteredValues.length > 9 && getUsersIsLoading === false &&
                                                <div className={styles.bottomTableDiv}>
                                                    <div>
                                                        <button
                                                            onClick={handlePreviousClick}
                                                            disabled={currentPage === 1}
                                                            className={styles.paginationPrevButton}
                                                        >
                                                            Previous
                                                        </button>
                                                        <button
                                                            onClick={handleNextClick}
                                                            disabled={currentPage === Math.ceil(filteredValues.length / itemsPerPage)}
                                                            className={styles.paginationNextButton}
                                                        >
                                                            Next
                                                        </button>
                                                    </div>
                                                    <div>
                                                        <span className={styles.paginationInfo}>
                                                            Page {currentPage} of {totalPages}
                                                        </span>
                                                    </div>

                                                </div>
                                            }
                                        </div>
                                    </>)
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default PendingOverboarding;